import Comments from '@/components/Comments';
import { fetchPost } from '@/services/supabase-service';
import { Post } from '@/types/type';
import { FontAwesome } from '@expo/vector-icons';
import { Image } from 'expo-image';
import { Link, useLocalSearchParams } from 'expo-router';
import { useVideoPlayer, VideoView } from 'expo-video';
import React, { useEffect, useState } from 'react';
import { SafeAreaView, ScrollView, StyleSheet, Text, View } from 'react-native';

const PostDetailsScreen = () => {
  const [currentPost, setCurrentPost] = useState<Post | null>(null);
  const { route, id } = useLocalSearchParams();
  const postId = Array.isArray(id) ? id[0] : id;

  const player = useVideoPlayer('', (player) => {
    player.loop = true;
  });

  useEffect(() => {
    const fetchData = async () => {
      const selectedPost = await fetchPost(postId);
      if (selectedPost && selectedPost.media_urls) {
        if (selectedPost.media_urls.length > 0 && selectedPost.media_urls[0].type === 'video') {
          player.replace({ uri: selectedPost.media_urls[0].url });
        }
      }
      setCurrentPost(selectedPost);
    };
    fetchData();
  }, [postId]);

  return (
    <SafeAreaView className="h-full w-full">
      <Comments
        id={currentPost?.id ?? ''}
        type="post"
        header={
          <View className="bg-white p-4 rounded-lg shadow-none w-full items-center m-1">
            {currentPost ? (
              <View className={`bg-white p-4 rounded-lg shadow-none w-full items-center m-1`}>
                <View className="relative w-full">
                  {currentPost.category === 'video' ? (
                    <View
                      style={styles.contentContainer}
                      className="scaler w-full min-h-[250px] h-full">
                      <VideoView
                        style={styles.video}
                        player={player}
                        allowsFullscreen
                        allowsPictureInPicture
                      />
                    </View>
                  ) : currentPost.media_urls && currentPost.media_urls.length > 0 ? (
                    <View className="w-full flex flex-row flex-wrap">
                      {currentPost.media_urls.map((media, index) => (
                        <View key={index} className="w-full p-4 h-[250px]">
                          <Image
                            source={{ uri: media.url }}
                            style={styles.image}
                            cachePolicy={'memory-disk'}
                            contentFit="contain"
                          />
                        </View>
                      ))}
                    </View>
                  ) : (
                    <View className="w-full p-4 h-[250px]">
                      <Image
                        source={
                          currentPost.image_url
                            ? currentPost.image_url
                            : require('../../assets/images/photo.svg')
                        }
                        style={styles.image}
                        contentFit="contain"
                        transition={500}
                        cachePolicy={'memory-disk'}
                      />
                    </View>
                  )}

                  <View className="absolute top-2 left-2 bg-white/90 rounded-lg px-2 py-1 h-[50px] flex justify-center items-center">
                    <Text className="text-xs font-bold text-orange-600"></Text>
                    <Text className="text-[10px] uppercase font-semibold text-gray-500"></Text>
                  </View>
                </View>

                <View className="w-full">
                  <Text className="text-xl font-semibold text-gray-900 mt-2 mb-2 line-clamp-2">
                    {currentPost.description}
                  </Text>

                  {currentPost.place && (
                    <Link
                      href={{ pathname: '/place-details', params: { id: currentPost.place.id } }}>
                      <View className="flex-row items-center mt-2 justify-between pr-12">
                        <View className="flex-row items-center">
                          <FontAwesome name="map-marker" size={16} color="black" />
                          <Text className="text-gray-500 text-xs flex-1">
                            {currentPost.place?.city} - {currentPost.place?.title}
                          </Text>
                        </View>
                      </View>
                    </Link>
                  )}

                  {currentPost.busker && (
                    <Link
                      href={{ pathname: '/busker-details', params: { id: currentPost.busker.id } }}>
                      <View className="flex-row items-center mt-2 justify-between pr-12">
                        <View className="flex-row items-center">
                          <FontAwesome name="user" size={16} color="black" />
                          <Text className="text-gray-500 text-xs flex-1 pl-2">
                            {currentPost.busker?.full_name}
                          </Text>
                        </View>
                      </View>
                    </Link>
                  )}
                </View>
              </View>
            ) : null}
          </View>
        }
      />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  image: {
    flex: 1,
    width: '100%',
    height: '100%',
    borderRadius: 8,
  },
  contentContainer: {
    flex: 1,
    padding: 10,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 50,
  },
  video: {
    width: '100%',
    height: '100%',
  },
  controlsContainer: {
    padding: 10,
  },
});

export default PostDetailsScreen;
